































import {Component, Mixins} from 'vue-property-decorator';
import MenuItemComponent from '@/components/layouts/base/MenuItemComponent.vue';
import BaseMenuComponent from '@/components/responsive/menu/BaseMenuComponent.vue';

@Component({
  components: {MenuItemComponent}
})
export default class WebMenuComponent extends BaseMenuComponent {
}
